@import '../../../../../constants/spacing.module.less';

@circle-size: 28px;

@step-is-in-progress-color: var(--grey-400);

@step-is-done-color: var(--blue-11003A);

.c-stepper {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin: @space-0;
  padding: @space-0;
  list-style: none;
}

.c-stepper-item {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: calc(@circle-size / 2);
    height: 1px;
    background-color: @step-is-in-progress-color;
    width: calc(50% - @circle-size / 2 - @space-8);
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }
}

.c-stepper-item-first {
  justify-content: flex-start;

  &::before {
    display: none;
  }
}

.c-stepper-item-last {
  justify-content: flex-end;

  &::after {
    display: none;
  }
}

.c-stepper-item-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.circle {
  width: @circle-size;
  height: @circle-size;
  border-radius: 50%;
  border: 6px solid @step-is-in-progress-color;
  flex-shrink: 0;
}

.prev {
  border-color: @step-is-done-color;
  background-color: @step-is-done-color;
}

.current {
  border-color: @step-is-done-color;
}

.done {
  border-color: @step-is-done-color;
  background-color: @step-is-done-color;
}

.c-stepper-item-done {
  &::before,
  &::after {
    background-color: @step-is-done-color;
  }
}

.c-stepper-item-prev {
  &::before,
  &::after {
    background-color: @step-is-done-color;
  }
}

.c-stepper-item-current {
  &::before {
    background-color: @step-is-done-color;
  }
}

.checkmark-icon {
  color: var(--grey-000);
  width: 14px;
  height: 14px;
}

.c-stepper-title {
  margin-top: @space-8;
  color: var(--blue-11003A);
  line-height: inherit;
  font-size: 14px;
  white-space: nowrap;
  text-align: center;
}

.c-stepper-title-prev {
  color: @step-is-done-color;
}
